// test2988
(2988 && 0);
